'use client';
import classNames from 'classnames/bind';
import React from 'react';
import styles from './SkipNavigation.module.scss.mjs';

const cx = classNames.bind(styles);
function SkipNavigation(_ref) {
  let {
    hasBottomNavi = true
  } = _ref;
  return /*#__PURE__*/React.createElement("div", {
    className: cx('article')
  }, /*#__PURE__*/React.createElement("a", {
    href: "#content",
    className: cx('link')
  }, "\uBCF8\uBB38 \uBC14\uB85C\uAC00\uAE30"), hasBottomNavi && ( /*#__PURE__*/React.createElement("a", {
    href: "#bottom-navigation",
    className: cx('link')
  }, "\uD398\uC774 \uC11C\uBE44\uC2A4\uBA54\uB274 \uBC14\uB85C\uAC00\uAE30")));
}

export { SkipNavigation as default };
